export default "__VITE_ASSET__DothzRj3__"